import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import MLVehicleOperatorTableComponent from '../MLVehicleOperatorTableComponent/MLVehicleOperatorTableComponent';

import metadata from './MLVehicleOperatorListPopup.metadata.json5';
import messages from './MLVehicleOperatorListPopup.messages';
import styles from './MLVehicleOperatorListPopup.module.scss';

const MLVehicleOperatorListPopup = (props) => {
    const {
        modalData: {
            vehicleOperators,
            driverType,
            canExcludeDrivers
        },
        addVehicleOperator,
        editVehicleOperator,
        removeVehicleOperator,
        getDriverTypeDisplayName,
        onCancel,
        submissionVM,
        viewModelService
    } = props;

    const isAMP = appConfig.portalCode === 'AMP';
    const translator = useTranslator();

    const addVehicleOperatorClicked = useCallback(() => {
        addVehicleOperator(onCancel);
    }, [addVehicleOperator, onCancel]);

    const editVehicleOperatorClicked = useCallback((item) => {
        editVehicleOperator(item, onCancel);
    }, [editVehicleOperator, onCancel]);

    const removeVehicleOperatorClicked = useCallback((item) => {
        removeVehicleOperator(item, onCancel);
    }, [removeVehicleOperator, onCancel]);
    
    const overrides = {
        contentContainer: {
            className: isAMP ? 'amp-ml-driver-table-popup' : 'ml-vehicle-operator-popup'
        },
        vehicleOperatorTableComponent: {
            vehicleOperators,
            onEdit: editVehicleOperatorClicked,
            onRemove: removeVehicleOperatorClicked,
            driverType,
            canExcludeDrivers,
            getDriverTypeDisplayName,
            onCancel,
            submissionVM,
            viewModelService
        },
        footer: {
            className: isAMP ? 'footer amp-footer-padding col-md-12' : 'footer col-md-12'
        },      
        addBtn: {
            content: translator(messages.addX, {
                driverType: getDriverTypeDisplayName(driverType, true)
            }),
            className: isAMP ? styles['amp-footer-button'] : ''
        }
    };

    const resolvers = {
        resolveComponentMap: {
            mlVehicleOperatorTableComponent: MLVehicleOperatorTableComponent
        },
        resolveCallbackMap : {
            addVehicleOperatorClicked
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );

};

MLVehicleOperatorListPopup.propTypes = {
    modelData: PropTypes.shape({
        vehicleOperators: PropTypes.array,
        driverType: PropTypes.string,
        canExcludeDrivers: PropTypes.bool
    }),
    addVehicleOperator: PropTypes.func,
    editVehicleOperator: PropTypes.func,
    removeVehicleOperator: PropTypes.func,
    getDriverTypeDisplayName: PropTypes.func,
    onCancel: PropTypes.func
};

export default MLVehicleOperatorListPopup;
